/*
* Copyright (C) Regione Lombardia
*/
import { Component } from '@angular/core';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-layout-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
})
export class LayoutLoaderComponent {

    constructor(
        public utilsService: UtilsService,
    ) { }

}
